module.exports = __webpack_public_path__ + "static/media/experience-beautiful-locations.ef9d1b61.webp";